import CaregiverInsurancePage from "../pages/CaregiverInsurancePage";
import ChildInsurancePage from "../pages/ChildInsurancePage";
import FetusInsurancePage from "../pages/FetusInsurancePage";

import CancerInsurancePage from "../pages/CancerInsurancePage";
import HealthInsurancePage from "../pages/HealthInsurancePage";
import SimpleInsurancePage from "../pages/SimpleInsurancePage";
import MedicalInsurancePage from "../pages/MedicalInsurancePage";
import YouthInsurancePage from "../pages/YouthInsurancePage";
import DementiaCareInsurancePage from "../pages/DementiaCareInsurancePage";

import DiagnosisPage from "../pages/DiagnosisPage";

import ChatbotPopupPage from "../pages/ChatbotPopupPage";
import LandingPage from "../pages/LandingPage";
import InsuranceProductsPage from "../pages/InsuranceProductsPage";
import PlannerPlatformPage from "../pages/PlannerPlatformPage";

import ReferralEventPage from "../pages/ReferralEventsPage";
import FetusReferralEventPage from "../pages/FetusReferralEventPage";
import ChildReferralEventPage from "../pages/ChildReferralEventPage";

import HistoryPage from "../pages/HistoryPage";
import FinanceServicePage from "../pages/FinanceServicePage";

export const ROUTES = [
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/caregiver",
    element: <CaregiverInsurancePage />,
    label: "간병보험",
  },
  { path: "/child", element: <ChildInsurancePage />, label: "어린이보험" },
  { path: "/fetus", element: <FetusInsurancePage />, label: "태아보험" },

  { path: "/cancer", element: <CancerInsurancePage />, label: "암보험" },
  { path: "/health", element: <HealthInsurancePage />, label: "종합건강보험" },
  { path: "/simple", element: <SimpleInsurancePage />, label: "간편보험" },
  { path: "/medical", element: <MedicalInsurancePage />, label: "실비보험" },
  { path: "/youth", element: <YouthInsurancePage />, label: "청년보험" },
  {
    path: "/dementia-care",
    element: <DementiaCareInsurancePage />,
    label: "치매간병보험",
  },
  { path: "/diagnosis", element: <DiagnosisPage />, label: "보험마스터" },

  { path: "/chatbot", element: <ChatbotPopupPage />, label: "챗봇" },

  {
    path: "/finance-services",
    element: <FinanceServicePage />,
    label: "금융 서비스",
  },
  { path: "/products", element: <InsuranceProductsPage />, label: "보험상품" },
  {
    path: "/platform",
    element: <PlannerPlatformPage />,
    label: "설계사플랫폼",
  },

  {
    path: "/events",
    element: <ReferralEventPage />,
    label: "이벤트",
  },
  {
    path: "/events/fetus",
    element: <FetusReferralEventPage />,
    label: "태아보험 상담 소개 이벤트",
  },
  {
    path: "/events/child",
    element: <ChildReferralEventPage />,
    label: "어린이보험 상담 소개 이벤트",
  },

  {
    path: "/history",
    element: <HistoryPage />,
    label: "히스토리",
  },
];

export const PATHS = {
  home: "/",
  caregiver: "/caregiver",
  child: "/child",
  fetus: "/fetus",

  cancer: "/cancer",
  health: "/health",
  simple: "/simple",
  medical: "/medical",
  youth: "/youth",
  dementiaCare: "/dementia-care",
  diagnosis: "/diagnosis",

  chatbot: "/chatbot",
  financeServices: "/finance-services",
  products: "/products",
  platform: "/platform",

  events: "/events",
  fetusReferralEvent: "/events/fetus",
  childReferralEvent: "/events/child",

  history: "/history",
};
